import { default } from './add-or-update-product.vue';
<template>
  <div class="product_info">
    <div class="title">
      <span style="cursor: pointer;" @click="$emit('addUpdateStatus')">产品中心</span>
      <span>></span>
      <span>产品详情</span>
     <!-- <el-button type="text" style="line-height: 3;" @click="updateInfo">编辑</el-button> -->
	  <el-button class="returnPre" @click="backProductCenter">返回</el-button>
    </div>
    <div class="content">
      <p class="title_p">{{ productInfo.title }}</p>
      <div
        class="text1"
        v-html="productInfo.content"
      >
      </div>
      <div class="text_image">
        <img :src="$getSrc(productInfo.imgUrl)" alt="">
      </div>
      <div
        class="text2"
        v-html="productInfo.content"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["productId"],
  data() {
    return {
      productInfo: {
        title: "",
        imgUrl: "",
        content: ""
      }
    };
  },
  mounted() {
    this.getProductInfo();
  },
  methods: {
    updateInfo() {
      this.$emit("edit");
    },
	
	backProductCenter() {
	  this.$emit("addUpdateStatus");
	  this.$emit("productIdSetNull");
	},

    // 产品详情
    getProductInfo() {
      this.$http({
        url: "getAccConInfoById",
        method: "post",
        params: {
          accConId: this.productId
        }
      })
      .then( ({data}) => {
        let { code, accContentEntity } = data;
        this.productInfo.title = accContentEntity.title;
        this.productInfo.imgUrl = accContentEntity.image;
        this.productInfo.content = accContentEntity.content;
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.product_info {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 25px;
    span:nth-child(2) {
      margin: 0 8px;
    }
    .el-button {
      float: right;
      margin-right: 30px;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
  .content {
    width: 860px;
    margin-left: 30px;
    .title_p {
      text-align: center;
      font-size: 28px;
      color: #333333;
      margin: 35px 0 64px 0;
    }
    .text_image {
      width: 100%;
      height: 323px;
      background-color: #e5e5e5;
      margin: 75px 0 67px 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text1,
    .text2 {
      font-size: 14px;
      color: #333333;
    }
    .text2 {
      margin-bottom: 100px;
    }
  }
}
</style>